import { useTheme } from "@/contexts/ThemeContext";
import { useEffect, useState } from "react";

export const AuroraBackground = () => {
  const { theme } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches || 'ontouchstart' in window);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Simplified background for mobile - no blur, no animations
  if (isMobile) {
    return (
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div
          className="absolute inset-0"
          style={{
            background: theme === "dark" 
              ? "linear-gradient(180deg, hsl(160 30% 6%) 0%, hsl(165 25% 10%) 100%)"
              : "linear-gradient(180deg, hsl(160 30% 92%) 0%, hsl(165 25% 94%) 50%, hsl(160 20% 96%) 100%)",
          }}
        />
        {/* Simple static gradient overlay for mobile */}
        <div
          className="absolute inset-0"
          style={{
            background: theme === "dark"
              ? "radial-gradient(ellipse 80% 50% at 50% 0%, hsl(160 60% 35% / 0.15), transparent 60%)"
              : "radial-gradient(ellipse 80% 50% at 50% 0%, hsl(160 50% 65% / 0.25), transparent 60%)",
          }}
        />
      </div>
    );
  }

  // Full desktop version with animations
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Base gradient - Emerald */}
      <div
        className="absolute inset-0"
        style={{
          background: theme === "dark" 
            ? "linear-gradient(180deg, hsl(160 30% 6%) 0%, hsl(165 25% 10%) 100%)"
            : "linear-gradient(180deg, hsl(160 30% 92%) 0%, hsl(165 25% 94%) 50%, hsl(160 20% 96%) 100%)",
        }}
      />
      
      {/* Aurora bands - Layer 1 (emerald/teal) */}
      <div 
        className="absolute inset-0 animate-aurora-shimmer will-change-transform"
        style={{
          background: theme === "dark"
            ? "linear-gradient(180deg, transparent 0%, hsl(160 84% 40% / 0.15) 20%, hsl(168 76% 45% / 0.2) 40%, transparent 60%)"
            : "linear-gradient(180deg, transparent 0%, hsl(160 60% 55% / 0.25) 25%, hsl(168 50% 60% / 0.3) 45%, transparent 65%)",
        }}
      />
      
      {/* Aurora bands - Layer 2 (green/teal) */}
      <div 
        className="absolute inset-0 animate-aurora-shimmer will-change-transform"
        style={{
          animationDelay: "-3s",
          background: theme === "dark"
            ? "linear-gradient(170deg, transparent 10%, hsl(168 80% 45% / 0.12) 30%, hsl(172 70% 50% / 0.15) 50%, transparent 70%)"
            : "linear-gradient(170deg, transparent 5%, hsl(165 60% 60% / 0.25) 30%, hsl(172 55% 65% / 0.2) 50%, transparent 70%)",
        }}
      />
      
      {/* Aurora bands - Layer 3 */}
      <div 
        className="absolute inset-0 animate-aurora-shimmer will-change-transform"
        style={{
          animationDelay: "-6s",
          background: theme === "dark"
            ? "linear-gradient(190deg, transparent 15%, hsl(155 70% 45% / 0.1) 35%, hsl(160 60% 40% / 0.12) 55%, transparent 75%)"
            : "linear-gradient(190deg, transparent 10%, hsl(160 55% 55% / 0.2) 35%, hsl(155 50% 60% / 0.25) 55%, transparent 75%)",
        }}
      />
      
      {/* Flowing gradient overlay */}
      <div 
        className="absolute inset-0 animate-aurora-flow opacity-50 will-change-transform"
        style={{
          background: theme === "dark"
            ? "linear-gradient(45deg, hsl(160 60% 35% / 0.1), hsl(168 70% 40% / 0.15), hsl(172 60% 45% / 0.1), hsl(165 50% 40% / 0.12))"
            : "linear-gradient(45deg, hsl(160 45% 65% / 0.2), hsl(165 50% 60% / 0.25), hsl(168 45% 65% / 0.2), hsl(162 40% 63% / 0.22))",
        }}
      />
      
      {/* Glowing orbs - emerald colors */}
      <div 
        className="absolute top-1/4 left-1/4 w-[400px] h-[400px] rounded-full blur-3xl animate-blob opacity-30 will-change-transform"
        style={{ 
          background: theme === "dark" 
            ? "radial-gradient(circle, hsl(160 70% 45% / 0.25), transparent 70%)" 
            : "radial-gradient(circle, hsl(160 50% 60% / 0.3), transparent 70%)" 
        }}
      />
      <div 
        className="absolute top-1/3 right-1/4 w-[450px] h-[450px] rounded-full blur-3xl animate-blob animation-delay-2000 opacity-25 will-change-transform"
        style={{ 
          background: theme === "dark" 
            ? "radial-gradient(circle, hsl(168 80% 45% / 0.2), transparent 70%)" 
            : "radial-gradient(circle, hsl(165 55% 55% / 0.25), transparent 70%)" 
        }}
      />
    </div>
  );
};